import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/service-evaluation.png'


const _withScopeId = n => (_pushScopeId("data-v-728a086e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn divider" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "content-wrapper" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "서비스 평가",
              onClick: $setup.goToSurvey,
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("footer", { class: "modal-footer" }, [
            _createElementVNode("button", {
              class: "btn btn-cancel",
              type: "button",
              onClick: $setup.onClickNoMoreShowForThreeDays,
              "aria-label": "3일 동안 보지 않기"
            }, " 3일 동안 보지 않기 "),
            _hoisted_3,
            _createElementVNode("button", {
              class: "btn btn-ok",
              type: "button",
              onClick: $setup.onClickClose,
              "aria-label": "닫기"
            }, " 닫기 ")
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.showSurveyModal]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}